(function () {
  'use strict';

  /* ============ Sticky product bar (product template) ============ */
  function initStickyBar() {
    const bar = document.querySelector('[data-sticky-bar]');
    const trigger = document.querySelector('[data-sticky-bar-trigger]');
    if (!bar || !trigger) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(trigger);
  }

  /* ============ FAQ accordion ============ */
  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(item => {
      const head = item.querySelector('[data-faq-head]');
      if (!head) return;
      head.addEventListener('click', () => {
        item.classList.toggle('is-open');
      });
    });
  }

  /* ============ Quantity selectors ============ */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(group => {
      const input = group.querySelector('input[type="number"]');
      const minus = group.querySelector('[data-qty-minus]');
      const plus = group.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', () => {
        const v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', () => {
        const v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============ Product gallery thumbnail switching ============ */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(gallery => {
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.src;
          if (src && main.tagName === 'IMG') main.src = src;
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ============ Variant bundle selector (pack sizes) ============ */
  function initBundleSelect() {
    document.querySelectorAll('[data-bundle]').forEach(group => {
      const options = group.querySelectorAll('[data-bundle-option]');
      const input = group.querySelector('[data-bundle-input]');
      options.forEach(opt => {
        opt.addEventListener('click', () => {
          options.forEach(o => o.classList.remove('is-selected'));
          opt.classList.add('is-selected');
          if (input) input.value = opt.dataset.variantId || '';
        });
      });
    });
  }

  /* ============ Filter pill toggle (collection page) ============ */
  function initFilterPills() {
    document.querySelectorAll('[data-filter-pill]').forEach(pill => {
      pill.addEventListener('click', () => {
        pill.classList.toggle('is-active');
      });
    });
  }

  /* ============ Mobile menu toggle ============ */
  function initMobileMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ============ Cart drawer (simple toggle, server handles state) ============ */
  function initCart() {
    const btn = document.querySelector('[data-cart-toggle]');
    const drawer = document.querySelector('[data-cart-drawer]');
    const close = document.querySelector('[data-cart-close]');
    if (!btn || !drawer) return;
    const open = () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const shut = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    btn.addEventListener('click', (e) => { e.preventDefault(); open(); });
    if (close) close.addEventListener('click', shut);
    drawer.addEventListener('click', (e) => { if (e.target === drawer) shut(); });
  }

  /* ============ Init on DOM ready ============ */
  function init() {
    initStickyBar();
    initFaq();
    initQuantity();
    initGallery();
    initBundleSelect();
    initFilterPills();
    initMobileMenu();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
